import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { ReportRelease } from 'src/app/model';
import { ReportProvider } from 'src/app/providers';
import {UserService, ToasterService, CommonService} from 'src/app/services';

@Component({
  selector: 'app-release-third-party-modal',
  templateUrl: './release-third-party-modal.component.html',
  styleUrls: ['./release-third-party-modal.component.scss']
})
export class ReleaseThirdPartyModalComponent implements OnInit {
  subject: Subject<boolean>;

  businessName: string = '';
  reportVersionId: string = '';

  @ViewChild('releaseForm') releaseForm: NgForm;
  releaseObj: ReportRelease = new ReportRelease();

  constructor(public bsModalRef: BsModalRef,
    public userService: UserService,
    private reportProvider: ReportProvider,
    private toastr: ToasterService,
              public commonService: CommonService) { }

  ngOnInit(): void {
  }

  /**
   * @description confirm click and release report
   */
  confirm(): void {
    this.reportProvider.releaseReport(this.reportVersionId, this.releaseObj).subscribe(res => {
      if (res.success) {
        this.toastr.success('Email sent successfully!');
        this.bsModalRef.hide();
        this.subject.next(true);
        this.subject.complete();
      }
    }, err => {
      // Error Handling
    });
  }

  /**
   * @description cancel click
   */
  decline(): void {
    this.bsModalRef.hide();
    this.subject.next(false);
    this.subject.complete();
  }

}
